import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { CampaignIncentiveSetsService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TCampaignIncentiveSet, TResponse } from '@shared/models';

@Component({
    'selector': 'app-campaignIncentiveSets',
    'templateUrl': './campaignIncentiveSets.page.html',
    'styleUrls': ['./campaignIncentiveSets.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class CampaignIncentiveSetsPage extends ViewBasePage implements OnInit, OnDestroy {
    public incentiveSets: TCampaignIncentiveSet[] = [];
    // private incentiveSetsSubscription: TCampaignIncentiveSet[];
    private incentiveSetsSubscription: any;

    constructor(private campaignIncentiveSetsService: CampaignIncentiveSetsService, 
        injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_CAMPAIGN_INCENTIVE_SETS);
    }

    public override ngOnInit(): void {
        const incentiveSetsObservable = this.campaignIncentiveSetsService.getObservable();
        this.incentiveSetsSubscription = incentiveSetsObservable.subscribe((incentiveSets: TCampaignIncentiveSet[]) => {
            this.incentiveSets = this.campaignIncentiveSetsService.sort(incentiveSets);
        });
        // this.initMoreMenu();
    }

    // public initMoreMenu(): void {
    //     this.resetPopoverMenu();
    //     this.pushPopoverMenuItem('Show Tour', 'show-campaign-incentive-sets-tour');
    // }

    public override ngOnDestroy(): void {
        this.incentiveSetsSubscription.forEach((subscription: any) => {
            subscription.unsubscribe();
        });
    }

    public onIncentiveSetClick(set: TCampaignIncentiveSet): void {
        this.router.navigateByUrl(`/marketing/campaignIncentiveSets/campaignIncentiveSet/${set.uid}`);
        // this.router.navigateByUrl('/marketing/campaigns');
    }

    public onAddIncentiveSetClick(): void {
        this.router.navigateByUrl('/marketing/campaignIncentiveSet');
    }

    public async confirmDeleteIncentiveSet(set: TCampaignIncentiveSet) {
        const question = 'Are you sure you want to delete incentive: ' + set.setName + '?';
        const response = await this.uxHelperService.showAlert('Confirm Delete', question);
        if (response.okay) {
            try {
                await this.uxHelperService.showSpinner('Deleting.');
                await this.campaignIncentiveSetsService.delete(set.uid);
                this.uxHelperService.showToast('Incentive Set has been deleted.');
            } catch (err) {
                const errorMessage = this.utilsService.extractError(err);
                this.uxHelperService.showAlert('Error', errorMessage);
            } finally {
                await this.uxHelperService.hideSpinner();
            }
        }
    }
}
